import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, styled, Typography } from '@mui/material';
import React, { useState } from 'react';
import somethingWentWrongUrl from '../../../../../../../assets/image/SomethingWentWrong.png';
import { useLocalStorageExecutorRoleServiceContext } from '../../../../context/contexts';
import { GraphQLError } from '../../../errors';
import { Error } from './Error';

const StyledButton = styled(Button)`
  background-color: #00a599;
  &:hover {
    background-color: rgba(27, 113, 107);
  }
`;

interface SomethingWentWrongErrorProps {
  error: Error;
}

const SomethingWentWrongError = (props: SomethingWentWrongErrorProps) => {
  const localStorageExecutorRoleService =
    useLocalStorageExecutorRoleServiceContext();
  const [clicked, setClicked] = useState(false);
  const { error } = props;

  return (
    <Error
      image={
        <img
          src={somethingWentWrongUrl}
          width={'100%'}
          height={'100%'}
          style={{ objectFit: 'contain' }}
        />
      }
      title={{ key: 'pages:errorBoundary.caution' }}
      message={(t) => {
        if (error instanceof GraphQLError) {
          const errorReference: string = error.errorReference ?? '';
          const setClipboardToErrorRef = () => {
            const type = 'text/plain';
            const blob = new Blob([errorReference], { type });
            const data = [new ClipboardItem({ [type]: blob })];

            setClicked(true);
            void navigator.clipboard.write(data);
          };
          return (
            <Typography variant="h5">
              {t('pages:errorBoundary.somethingWentWrongWithRef', {
                ref: errorReference,
              })}
              {clicked ? (
                <CheckIcon />
              ) : (
                <ContentCopyIcon
                  onClick={setClipboardToErrorRef}
                  color="primary"
                  style={{ cursor: 'pointer' }}
                />
              )}
            </Typography>
          );
        } else {
          return (
            <Typography variant="h5">
              {t('pages:errorBoundary.message')}
            </Typography>
          );
        }
      }}
      exit={(t) => {
        const redirectToHome = () => {
          localStorageExecutorRoleService.clear();
          window.location.pathname = '/';
        };
        return (
          <StyledButton
            variant="contained"
            color="primary"
            onClick={redirectToHome}
          >
            {t('pages:errorBoundary.goToHome')}
          </StyledButton>
        );
      }}
    />
  );
};

export default SomethingWentWrongError;
